module.exports = __webpack_public_path__ + "static/media/yahoo.fcd893ff.png";